export const pathMatcher = (urlPath: string, searchPath: string) => {
  if (
    urlPath === searchPath ||
    (searchPath.length > 1 && urlPath.startsWith(searchPath.slice(0, searchPath.length - 2))) ||
    (searchPath === '/gmp' &&
      (urlPath.startsWith('/task') ||
        urlPath.startsWith('/message') ||
        urlPath.startsWith('/submit-gateway')))
  )
    return true;
  return false;
};
